// extracted by mini-css-extract-plugin
export var label = "_f3-2";
export var slideContainer = "_f3-0";
export var slider = "_f3-1";